import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PrivacyPolicy() {
  const updated = "February 2026";
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20">
        <p className="text-sm font-bold uppercase tracking-widest text-[#64748B] mb-3">
          Privacy
        </p>
        <h1
          data-testid="privacy-title"
          className="font-display font-black text-4xl md:text-5xl tracking-tight mb-3"
        >
          Privacy Policy
        </h1>
        <p className="text-sm text-[#64748B] font-medium mb-10">
          Last updated: {updated}
        </p>

        <div className="space-y-6 text-[#1F2937] text-base leading-relaxed">
          <section>
            <h2 className="font-display font-black text-2xl mb-2">Overview</h2>
            <p>
              TeacherToolsLab.com is a free educational tool website. We respect
              your privacy and have built this site to collect as little information
              as possible.
            </p>
          </section>

          <section>
            <h2 className="font-display font-black text-2xl mb-2">
              What we collect
            </h2>
            <p>
              <strong>Account information:</strong> The rubric generator does not
              require an account. You do not need to register, log in, or provide
              personal information to use it.
            </p>
            <p className="mt-2">
              <strong>Rubric data:</strong> The rubrics you generate are created
              entirely in your browser and are not saved to our servers in this
              version of the site.
            </p>
            <p className="mt-2">
              <strong>Analytics:</strong> We may use privacy-respecting analytics
              to understand which tools are most useful (page views, anonymous
              session counts). We do not sell or share data with advertisers.
            </p>
          </section>

          <section>
            <h2 className="font-display font-black text-2xl mb-2">Cookies</h2>
            <p>
              The site may use a small number of essential cookies for layout
              preferences. It does not use advertising cookies.
            </p>
          </section>

          <section>
            <h2 className="font-display font-black text-2xl mb-2">
              Third-party links
            </h2>
            <p>
              Our "Printable Resources" cards may link to external storefronts (for
              example, Etsy, Gumroad, or Payhip). Those sites have their own
              privacy policies and are not controlled by TeacherToolsLab.
            </p>
          </section>

          <section>
            <h2 className="font-display font-black text-2xl mb-2">Children</h2>
            <p>
              TeacherToolsLab is intended for use by educators, parents, and
              tutors. We do not knowingly collect personal information from
              children.
            </p>
          </section>

          <section>
            <h2 className="font-display font-black text-2xl mb-2">Contact</h2>
            <p>
              Questions about this policy? Email us at{" "}
              <a href="mailto:hello@teachertoolslab.com" className="underline font-semibold">
                hello@teachertoolslab.com
              </a>
              .
            </p>
          </section>

          <section className="text-sm text-[#64748B] border-t border-[#E5E7EB] pt-6 mt-10">
            <p>
              This website provides general educational resources and is not
              affiliated with any state education department.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
